import { HeadingProps } from "../../Types/CommonElementType";

const H6:React.FC<HeadingProps> = (props) => {
  return (
    <h6 {...props} style={props.style}>
      {props.children}
    </h6>
  );
};

export default H6;
